import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ImageWithLoader, ListSocial, Svg } from "app/components";
import { EntityInfo, printInfo, Width50 } from "app/components/Entity";
import { generatePath, NavLink } from "react-router-dom";
import { AsideCinemaDetails } from "./styles";
import routes from "config/common/routes";
import { useConfig } from "app/hooks";

const propTypes = {
  cinemaDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.any]),
  isVisible: PropTypes.bool.isRequired,
  setShowMap: PropTypes.func.isRequired
};

const defaultProps = {
  cinemaDetails: null
};

const Aside = ({
  cinemaDetails,
  isVisible,
  social,
  sendUrl,
  gastronomySendUrl,
  country,
  cinemaExtraInfo,
  phoneNumber,
  address,
  mapRef,
  setShowMap,
  legalInfo
}) => {
  const [t, i18n] = useTranslation();
  const {
    name,
    image,
    workingHours,
    publicTransport,
    parkingInfo,
    description,
    arrivalInfo
  } = cinemaDetails;

  const {
    media: { docsPrefix }
  } = useConfig();
  const isPhoneNumber = true;

  const languageContents = useMemo(
    () => ({
      freeparking:
        i18n.language === "en" || i18n.language === "en-US"
          ? "freeparkingEN"
          : "freeparking"
    }),
    [i18n.language]
  );

  const handleMap = () => {
    setShowMap(true);
    setTimeout(() => {
      window.scrollTo({
        top: mapRef.current.offsetTop - 100,
        left: 0,
        behavior: "smooth"
      });
    }, 500);
  };

  return (
    <AsideCinemaDetails isVisible={isVisible}>
      <ImageWithLoader type="cinema" imgSrc={image} imgTitle={name} />
      <div className="s-entity-details__aside-inner">
        <EntityInfo>
          <div className="b-entity-info__row">
            <div className="width-100">
              <Width50>
                <NavLink
                  to={{
                    pathname: generatePath(routes.hallInfo.pattern, {
                      id: cinemaDetails?.linkedHallInfo
                        ? cinemaDetails?.linkedHallInfo
                        : 0
                    }),
                    state: { hallId: cinemaDetails?.linkedHallInfo }
                  }}
                  className="s-cinema-details__link-prices"
                >
                  <strong>{t("cinemas.hall_info")}</strong>
                  <Svg id="hall" />
                </NavLink>
              </Width50>
              {Object.keys(gastronomySendUrl).length > 0 && (
                <Width50>
                  <NavLink
                    to={gastronomySendUrl}
                    className="s-cinema-details__link-prices"
                  >
                    <strong>{t("cinemas.gastronomy")}</strong>
                    <Svg id="gastronomy" />
                  </NavLink>
                </Width50>
              )}
            </div>
          </div>
          {printInfo(workingHours, t("cinemas.w_hours"))}
          {printInfo(address, t("cinemas.address"))}
          <div className="go_map">
            <button
              type="button"
              className="s-cinema-details__address-btn-map"
              onClick={handleMap}
            >
              {t("cinemas.map")}
            </button>
          </div>
          {printInfo(phoneNumber, t("cinemas.phone_number"), isPhoneNumber)}
          <div className="b-entity-info__row">
            <div className="display-inline">
              {cinemaExtraInfo?.[languageContents.freeparking] && (
                // <ul>
                //   <li>
                <>
                  <Svg id="car" />

                  <span
                    className="text-inline"
                    dangerouslySetInnerHTML={{
                      __html: cinemaExtraInfo?.[languageContents.freeparking]
                    }}
                  />
                </>
                //   </li>
                // </ul>
              )}
            </div>
          </div>
          {printInfo(publicTransport, t("cinemas.transportation"))}
          {printInfo(arrivalInfo, t("cinemas.arrival"))}
          {printInfo(parkingInfo, t("cinemas.parking"))}
          {printInfo(description, t("cinemas.additional_info"))}
          <div className="b-entity-info__row">
            <NavLink to={sendUrl} className="s-cinema-details__link-prices">
              <Svg id="document" />
              {/* {country !== 'aut' && (
                <span className="s-cinema-details__link-prices-text">{t('common.price_list')}</span>
              )} */}
              <span className="text-upper">{t("cinemas.pricelist")}</span>
            </NavLink>
          </div>
          {country !== "rou" ||
            (country !== "aut" && (
              <div className="b-entity-info__row">
                <a
                  href={docsPrefix(legalInfo[0]?.doc)}
                  target="_blank"
                  className="s-cinema-details__link-prices"
                >
                  <Svg id="document" />
                  <span className="text-upper">
                    {t("cinemas.operating_regulations")}
                  </span>
                </a>
              </div>
            ))}
          <div className="b-entity-info__row">
            {social && social.length ? <ListSocial items={social} /> : null}
          </div>
        </EntityInfo>
      </div>
    </AsideCinemaDetails>
  );
};

Aside.propTypes = propTypes;
Aside.defaultProps = defaultProps;
export default Aside;
